<div class="font-10 cout-portion-pondere" *ngIf="displayCoutsDetails" title="coût portion pondéré" >
 {{menuCompo.coutPortionPondereEffPrev | currency:'EUR':'symbol':'1.4-4'}}
</div>
